import RocketMobile from './icons/rocket-gray-mobile.svg';
import ChatMobile from './icons/chat-gray-mobile.svg';

const IconsPackMobile = Object.freeze({
  RocketMobile,
  ChatMobile,
});

export default IconsPackMobile;
